// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cZhQx","checkmark":"styles_checkmark__NtgsT","label":"styles_label__DtY9y"};